import { useLanguage } from "../context/LanguageContext";
import { Globe, ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";
import { Link } from "react-router-dom";

const privacyContent = {
  es: {
    title: "Política de Privacidad",
    backHome: "Volver al inicio",
    sections: [
      {
        title: "1. Responsable del tratamiento",
        content: `Global Tech Xperts B.V. es el responsable del tratamiento de los datos personales que usted nos facilita a través de este sitio web, de nuestros formularios instantáneos en TikTok Ads y de la reserva de reuniones. El tratamiento se realiza conforme al Reglamento (UE) 2016/679 (RGPD) y a la normativa de protección de datos aplicable.

Datos de contacto del responsable:
• Razón social: Global Tech Xperts B.V.
• KvK (Registro Mercantil de los Países Bajos): 97248991
• Domicilio: Westblaak 92, unit 3.04, 3012KM Rotterdam, The Netherlands
• Email: adm@globaltechxperts.nl
• Teléfono: +31645282452`
      },
      {
        title: "2. Datos personales que recopilamos",
        content: `a) Formulario de contacto de la web
Cuando envía el formulario de contacto de este sitio web recopilamos los datos que usted indica:
• Nombre
• Empresa y cargo
• Email y teléfono / WhatsApp
• País
• Servicio de interés, volumen aproximado y frecuencia de compra
• País de origen de la mercancía
• Mensaje adicional
• Cómo nos ha conocido
• Idioma de preferencia

b) Formulario instantáneo de TikTok Ads
Cuando una persona envía nuestro formulario instantáneo en TikTok, recibimos los datos que facilita en él:
• Nombre, email y teléfono
• Empresa y cargo
• Si representa a una empresa o trabaja como autónomo
• Si importa actualmente desde fuera de la UE o tiene una importación prevista en los próximos tres meses
• Producto, país de origen, importe aproximado del pedido y fecha prevista de importación

c) Reserva de reuniones (Calendly)
Si decide reservar una reunión mediante nuestro enlace de Calendly, los datos que introduce en esa reserva (nombre, email y, en su caso, la información adicional que indique) se tramitan a través de Calendly para gestionar la cita. La reserva es opcional.

d) Cookies
La información sobre las cookies utilizadas en este sitio web y la gestión de su consentimiento se recoge en nuestra Política de Cookies.`
      },
      {
        title: "3. Finalidad del tratamiento",
        content: `Utilizamos las solicitudes recibidas por la web y por TikTok para:
• Evaluar la operación de importación que nos plantea
• Responder a su consulta
• Contactar con usted por email, teléfono o WhatsApp en relación con su solicitud
• Si usted lo solicita, organizar una reunión

Enviar una consulta no supone suscribirse a comunicaciones comerciales ajenas a esa solicitud. Solo le enviaremos comunicaciones comerciales no relacionadas con su consulta si ha marcado expresamente la casilla opcional de comunicaciones comerciales del formulario de contacto de la web.`
      },
      {
        title: "4. Legitimación del tratamiento",
        content: `La base legal para el tratamiento de sus datos es:
• La aplicación de medidas precontractuales a petición suya (art. 6.1.b RGPD), al solicitar información o una propuesta sobre nuestros servicios
• El interés legítimo de Global Tech Xperts B.V. en atender las consultas recibidas (art. 6.1.f RGPD)
• Su consentimiento (art. 6.1.a RGPD) para el envío de comunicaciones comerciales, únicamente cuando haya marcado la casilla opcional correspondiente, y para las cookies no esenciales`
      },
      {
        title: "5. TikTok y reserva de reuniones",
        content: `TikTok recoge los datos que usted envía mediante su formulario instantáneo y los pone a disposición de Global Tech Xperts B.V. TikTok también trata su información conforme a su propia política de privacidad y a sus condiciones de generación de contactos. Ambas entidades actúan como responsables de sus respectivos tratamientos.

Si decide reservar una reunión mediante nuestro enlace de Calendly, los datos de esa reserva se tramitan a través de Calendly para gestionar la cita. Puede consultar la política de privacidad de Calendly en su sitio web. La reserva es opcional.`
      },
      {
        title: "6. Destinatarios de los datos",
        content: `Sus datos pueden ser tratados por los proveedores que utilizamos para prestar el servicio (alojamiento web, herramientas de gestión de contactos, envío de email, TikTok para la recepción de formularios instantáneos y Calendly para la reserva de reuniones), que actúan por cuenta de Global Tech Xperts B.V. o como responsables independientes según lo indicado en esta política.

No cedemos sus datos a otros terceros salvo obligación legal.`
      },
      {
        title: "7. Conservación de los datos",
        content: `Conservamos sus datos mientras sean necesarios para atender su solicitud y, en su caso, mientras se mantenga la relación comercial, así como durante el tiempo exigido por las obligaciones legales aplicables. Puede solicitar su supresión en cualquier momento en adm@globaltechxperts.nl.`
      },
      {
        title: "8. Derechos del usuario",
        content: `Puede ejercer los siguientes derechos:
• Acceso: conocer qué datos personales tratamos
• Rectificación: corregir datos inexactos
• Supresión: solicitar la eliminación de sus datos
• Oposición: oponerse al tratamiento
• Limitación: solicitar la limitación del tratamiento
• Portabilidad: recibir sus datos en un formato estructurado
• Retirar el consentimiento en cualquier momento, sin que ello afecte a la licitud del tratamiento anterior

Para ejercer estos derechos, escríbanos a: adm@globaltechxperts.nl

También puede presentar una reclamación ante la autoridad de protección de datos competente, incluida la Autoriteit Persoonsgegevens de los Países Bajos (www.autoriteitpersoonsgegevens.nl) o la Agencia Española de Protección de Datos (www.aepd.es), según corresponda.`
      },
      {
        title: "9. Cambios en la política de privacidad",
        content: `Global Tech Xperts B.V. puede modificar esta política de privacidad para adaptarla a cambios legislativos o a la evolución de nuestros servicios. La versión vigente estará siempre disponible en esta página, con su fecha de revisión.`
      }
    ],
    lastUpdate: "Última revisión: 20 de junio de 2026"
  },
  en: {
    title: "Privacy Policy",
    backHome: "Back to home",
    sections: [
      {
        title: "1. Data Controller",
        content: `Global Tech Xperts B.V. is the data controller of the personal data you provide through this website, our TikTok Ads instant forms and meeting bookings. Processing is carried out in accordance with Regulation (EU) 2016/679 (GDPR) and applicable data protection legislation.

Contact details of the controller:
• Company name: Global Tech Xperts B.V.
• KvK (Dutch Chamber of Commerce): 97248991
• Address: Westblaak 92, unit 3.04, 3012KM Rotterdam, The Netherlands
• Email: adm@globaltechxperts.nl
• Phone: +31645282452`
      },
      {
        title: "2. Personal data we collect",
        content: `a) Website contact form
When you submit the contact form on this website we collect the data you provide:
• Name
• Company and position
• Email and phone / WhatsApp
• Country
• Service of interest, approximate volume and purchase frequency
• Country of origin of the goods
• Additional message
• How you heard about us
• Language preference

b) TikTok Ads instant form
When someone submits our instant form on TikTok, we receive the data they provide in it:
• Name, email and phone
• Company and position
• Whether they represent a company or work as a freelancer
• Whether they currently import from outside the EU or have an import planned within the next three months
• Product, country of origin, approximate order value and expected import date

c) Meeting bookings (Calendly)
If you choose to book a meeting through our Calendly link, the data you enter in that booking (name, email and any additional information you provide) is processed through Calendly to manage the appointment. Booking is optional.

d) Cookies
Information about the cookies used on this website and how to manage your consent is set out in our Cookie Policy.`
      },
      {
        title: "3. Purpose of processing",
        content: `We use the requests received through the website and TikTok to:
• Assess the import operation you describe
• Respond to your enquiry
• Contact you by email, phone or WhatsApp in relation to your request
• Arrange a meeting, if you request one

Submitting an enquiry does not subscribe you to commercial communications unrelated to that request. We will only send you commercial communications unrelated to your enquiry if you have expressly ticked the optional commercial communications box on the website contact form.`
      },
      {
        title: "4. Legal basis for processing",
        content: `The legal basis for processing your data is:
• Taking pre-contractual steps at your request (Art. 6(1)(b) GDPR) when you ask for information or a proposal about our services
• The legitimate interest of Global Tech Xperts B.V. in handling the enquiries received (Art. 6(1)(f) GDPR)
• Your consent (Art. 6(1)(a) GDPR) for commercial communications, only where you have ticked the corresponding optional box, and for non-essential cookies`
      },
      {
        title: "5. TikTok and meeting bookings",
        content: `TikTok collects the data you submit through its instant form and makes it available to Global Tech Xperts B.V. TikTok also processes your information in accordance with its own privacy policy and lead generation terms. Both entities act as controllers of their respective processing.

If you choose to book a meeting through our Calendly link, the booking data is processed through Calendly to manage the appointment. Calendly's privacy policy is available on its website. Booking is optional.`
      },
      {
        title: "6. Data recipients",
        content: `Your data may be processed by the providers we use to deliver our service (web hosting, contact management tools, email delivery, TikTok for receiving instant forms and Calendly for meeting bookings), acting on behalf of Global Tech Xperts B.V. or as independent controllers as described in this policy.

We do not share your data with other third parties unless required by law.`
      },
      {
        title: "7. Data retention",
        content: `We keep your data for as long as necessary to handle your request and, where applicable, for the duration of the business relationship, as well as for the period required by applicable legal obligations. You may request deletion at any time at adm@globaltechxperts.nl.`
      },
      {
        title: "8. Your rights",
        content: `You may exercise the following rights:
• Access: know what personal data we process
• Rectification: correct inaccurate data
• Erasure: request deletion of your data
• Objection: object to processing
• Restriction: request restriction of processing
• Portability: receive your data in a structured format
• Withdraw consent at any time, without affecting the lawfulness of prior processing

To exercise these rights, write to: adm@globaltechxperts.nl

You may also lodge a complaint with the competent data protection authority, including the Dutch Autoriteit Persoonsgegevens (www.autoriteitpersoonsgegevens.nl) or the Spanish Data Protection Agency, AEPD (www.aepd.es), as applicable.`
      },
      {
        title: "9. Changes to this privacy policy",
        content: `Global Tech Xperts B.V. may amend this privacy policy to reflect legislative changes or developments in our services. The current version will always be available on this page, together with its revision date.`
      }
    ],
    lastUpdate: "Last revised: 20 June 2026"
  }
};

export default function PrivacyPolicyPage() {
  const { language } = useLanguage();
  const content = privacyContent[language];

  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      {/* Header */}
      <header className="glass border-b border-neutral-800/50 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-orange-500 to-amber-400 flex items-center justify-center shadow-lg">
                <Globe className="w-5 h-5 text-white" />
              </div>
              <span className="font-bold text-lg tracking-tight text-white font-['Outfit']">
                Global Tech Xperts
              </span>
            </Link>
            <Link to="/">
              <Button variant="outline" className="rounded-full border-neutral-700 text-neutral-300 hover:bg-neutral-800 gap-2">
                <ArrowLeft className="w-4 h-4" />
                {content.backHome}
              </Button>
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-bold text-white font-['Outfit'] mb-8" data-testid="privacy-title">{content.title}</h1>
        
        <div className="space-y-8" data-testid="privacy-sections">
          {content.sections.map((section) => (
            <div key={section.title} className="glass rounded-2xl p-6">
              <h2 className="text-xl font-bold text-white mb-4">{section.title}</h2>
              <p className="text-neutral-400 whitespace-pre-line">{section.content}</p>
            </div>
          ))}
        </div>

        <p className="text-neutral-500 text-sm mt-8">{content.lastUpdate}</p>
      </main>

      {/* Footer */}
      <footer className="border-t border-neutral-800 py-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-neutral-500 text-sm">
          © {new Date().getFullYear()} Global Tech Xperts B.V. {language === "es" ? "Todos los derechos reservados." : "All rights reserved."}
        </div>
      </footer>
    </div>
  );
}
